/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import React from "react";
import PropTypes from "prop-types";

let REQUIRED_FIELD_SYMBOL = "*";

function Label(props) {
    const { label, required, id, size } = props;
    if (!label) {
        return (<div className={"col-sm-2"}></div>);
    }
    return (
        <label className="col-sm-2 control-label" htmlFor={id}>
            {required ? label + REQUIRED_FIELD_SYMBOL : label}
        </label>
    );
}

class StandardTemplate extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        classNames: PropTypes.string,
        label: PropTypes.string,
        children: PropTypes.node.isRequired,
        errors: PropTypes.element,
        rawErrors: PropTypes.arrayOf(PropTypes.string),
        help: PropTypes.element,
        rawHelp: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        description: PropTypes.element,
        rawDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        hidden: PropTypes.bool,
        required: PropTypes.bool,
        readonly: PropTypes.bool,
        displayLabel: PropTypes.bool,
        fields: PropTypes.object,
        formContext: PropTypes.object,
        schema: PropTypes.object.isRequired,
        uiSchema: PropTypes.object
    };

    static defaultProps = {
        hidden: false,
        readonly: false,
        required: false,
        displayLabel: true,
        uiSchema: {}
    };

    /**
     * Label size (bootstrap grid cell count)
     * @returns {number}
     */
    getLabelClass() {
        return "col-sm-2 control-label";
    }

    /**
     * Input size (boostrap grid cell count)
     * @returns {number}
     */
    getFieldClass() {
        return "col-sm-10";
    }

    getTemplateClassName(){
        return this.props.classNames;
    }

    renderLabel() {
        let title = this.props.label;
        if (this.props.uiSchema["ui:title"]) title = this.props.uiSchema["ui:title"];

        // Overriding react-jsonschema-form implementation of displayLabel:
        // Label will be always shown except when widget is checkbox
        if (
            this.props.uiSchema["ui:widget"] === "checkbox" ||
            this.props.schema.type === "boolean" ||
            title == null || title === "") {
            return (
                <div className={this.getLabelClass()}/>
            );
        }

        return (
            <label className={this.getLabelClass()} htmlFor={this.props.id}>
                {this.props.required ? title + REQUIRED_FIELD_SYMBOL : title}
            </label>
        );
    }

    renderField() {
        const {
            children,
            errors,
            help,
            description,
        } = this.props;
        return (
            <div className={this.getFieldClass()}>
                {children}
                {description}
                {errors}
                {help}
            </div>
        );
    }

    render() {
        if (this.props.hidden) return this.props.children;

        return (
            <div className={this.getTemplateClassName()}>
                {this.renderLabel()}
                {this.renderField()}
            </div>
        );
    }
}

export default StandardTemplate;
